import { sessionStore } from "@/Globals/Stores/SessionStore";
import { CancellableWorkflowStep } from "../../BaseWorkflow/Steps/CancellableWorkflowStep";
import { LoginWorkflowStepEnum } from "../LoginWorkflowStepEnum";

class LoginMandatoryMultiFactorAuthenticationFlowStep extends CancellableWorkflowStep<LoginWorkflowStepEnum> {
    public constructor() {
        super(LoginWorkflowStepEnum.RequiredMandatoryMultiFactorAuthenticationSetUpFlow);
    }

    public isValid(): boolean {
        return (
            cacheStore.ClinicSettings.EnableMandatoryMultifactorAuthentication
            && sessionStore.IsMultifactorAuthenticationRequired
            && !sessionStore.IsMultifactorAuthenticationEnabled
        );
    }

    public isCompleted(): boolean {
        return sessionStore.IsMultifactorAuthenticationEnabled;
    }

    public cancel(): void {
        sessionStore.loginWorkflow.nextStep();
    }
}

export { LoginMandatoryMultiFactorAuthenticationFlowStep };
